import React, { useState } from "react";
import "./HorizontalTabs.css";

interface HorizontalTabInterface {
  id: number;
  title: string;
  component: React.ReactNode;
  disabled?: boolean;
}

interface HorizontalTabsProps {
  tabs: HorizontalTabInterface[];
  className?: string;
  onChange?: (id: number) => void;
  value?: number;
}

const HorizontalTabs: React.FC<HorizontalTabsProps> = ({
  tabs,
  className,
  onChange,
  value,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<number | null>(1);

  const activeTab = value !== undefined ? value : internalActiveTab;

  const handleTabClick = (e: React.MouseEvent<HTMLDivElement>, tab: HorizontalTabInterface) => {
    e.stopPropagation();
    e.preventDefault();
    if (tab.disabled) return;
    if (value === undefined) {
      setInternalActiveTab(tab.id);
    }
    if (onChange) onChange(tab.id);
  };

  return (
    <div className={`horizontal-tabs-container ${className ? className : ""}`}>
      <div className="horizontal-tabs">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`horizontal-tab-header ${
              activeTab === tab.id ? "open" : ""
            }${tab.disabled ? " disabled" : ""}`}
            onClick={(e) => handleTabClick(e, tab)}
          >
            <span>{tab.title}</span>
          </div>
        ))}
      </div>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`horizontal-tab-content ${
            activeTab === tab.id ? "active" : ""
          }`}
        >
          {tab.component}
        </div>
      ))}
    </div>
  );
};

export default HorizontalTabs;
